import { BaseIcon, BaseIconProps } from './BaseIcon';

export const LayersGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="layersGrad" {...props}>
    <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" stroke="url(#layersGrad)" />
    <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65M22 12.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" stroke="url(#layersGrad)" />
  </BaseIcon>
);
